import React from "react";
import { Skeleton } from "@/components/ui/skeleton";

const TableSkeleton: React.FC = () => {
  return (
    <div className="space-y-4">
      <div className="flex justify-between">
        <Skeleton className="h-10 w-[250px]" />
        <Skeleton className="h-10 w-[200px]" />
      </div>
      <div className="border rounded-md">
        <div className="h-12 border-b px-4 bg-muted/50" />
        {[...Array(5)].map((_, i) => (
          <div key={i} className="flex px-4 py-3 border-b last:border-0">
            <Skeleton className="h-6 w-full" />
          </div>
        ))}
      </div>
    </div>
  );
};

export default TableSkeleton;
